import { useMedia } from './useMediaQuery';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export const usePaginationConfig = ({
    currentPage = 1,
    defaultCurrent = 1,
    pageSize = 5,
    total = 0,
    onChange,
    localStorageKey = 'tablePaginationConfig',
    showSizeChanger = true,
    pageSizeOptions = [5, 10, 20, 50, 100],
    position = ['bottomRight'],
    className = '',
}) => {
    const { t } = useTranslation(['transactions']);
    const { isSmallDevice } = useMedia();

    return useMemo(() => {
        const handleChange = (page, size) => {
            if (localStorageKey) {
                localStorage.setItem(`${localStorageKey}Page`, page);
                localStorage.setItem(`${localStorageKey}PageSize`, size);
            }

            if (onChange) {
                onChange(page, size);
            }
        };

        return {
            position,
            pageSize,
            current: currentPage,
            defaultCurrent,
            total,
            onChange: handleChange,
            pageSizeOptions,
            showSizeChanger: showSizeChanger && total > pageSizeOptions[0],
            showTotal: (total, range) => t('transactions:items-range', { from: range[0], to: range[1], total }),
            className,
            locale: {
                items_per_page: t('transactions:items-per-page'),
                next_3: t('transactions:next-3'),
                prev_3: t('transactions:prev-3'),
            },
            showLessItems: true,
            size: isSmallDevice ? 'small' : 'large',
        };
    }, [
        className,
        defaultCurrent,
        currentPage,
        isSmallDevice,
        localStorageKey,
        onChange,
        pageSize,
        pageSizeOptions,
        position,
        showSizeChanger,
        t,
        total,
    ]);
};
